import type { ReactNode } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
//import { createBrowserHistory } from 'history';

// Needed
//export const history = createBrowserHistory();

interface IRouterProvider {
  children: ReactNode;
}

export const RouterProvider = ({ children }: IRouterProvider): JSX.Element => <Router>{children}</Router>;
